'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data"];
import { MessageTypes } from '../Constants';
const proxyRequest = (messenger, method, url, options = {}) => {
  const {
      data
    } = options,
    rest = _objectWithoutPropertiesLoose(options, _excluded);
  const requestData = typeof data !== 'undefined' ? JSON.stringify(data) : null;
  return messenger.postMessage(Object.assign({
    type: MessageTypes.API_REQUEST,
    data: requestData,
    method,
    url
  }, rest));
};
const notImplemented = () => {
  return () => {
    throw new Error('[interframe] hub-http method not implemented in proxy');
  };
};

/*
 * Creates an API client that shares the same interface as `hub-http` clients
 * so that code API request code can be written such that sending an API request
 * from an iframe is the same as sending an API request directly with hub-http.
 *
 * The implementation requires that the `api-responder` middleware is hooked up
 * to the instance of interframe running in the app window that is receiving
 * messages.
 *
 * postMessage message shape:
 *
 * {
 *   type: 'api-request',
 *   method: httpMethod, // GET, POST, PUT, etc…
 *   timeout: 7000,
 *   data: serialize to JSON,
 *   query,
 *  }
 */
export const getApiClient = messenger => {
  const client = (url, options) => {
    return proxyRequest(messenger, 'GET', url, options);
  };
  const withMethod = method => {
    return (url, options) => {
      return proxyRequest(messenger, method, url, options);
    };
  };
  return Object.assign(client, {
    get: withMethod('GET'),
    post: withMethod('POST'),
    put: withMethod('PUT'),
    patch: withMethod('PATCH'),
    delete: withMethod('DELETE'),
    // not implemented methods
    options: notImplemented(),
    getWithResponse: notImplemented(),
    postWithResponse: notImplemented(),
    putWithResponse: notImplemented(),
    patchWithResponse: notImplemented(),
    deleteWithResponse: notImplemented(),
    optionsWithResponse: notImplemented()
  });
};